// extracted by mini-css-extract-plugin
export default {"Cross":"Cross_Cross__2jANE","Line":"Cross_Line__WZ5DI"};